import type HttpClient from "../../tastyworks/http"
import type { RequestOptions } from "../../tastyworks/http"
import {
  MarginDryRunRejectedError,
  parseMarginDryRunResult,
  type MarginDryRunResult,
} from "../../tastyworks/margin-dry-run"
import {
  extractErrorMessage,
  parseSingleResponse,
} from "../../tastyworks/response"
import type { JsonMap } from "../../tastyworks/util/json"

const REQUEST_FAILED_MESSAGE = "Margin dry run request failed"

export class MarginDryRunService {
  private readonly marginAccountClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.marginAccountClient = baseHttpClient.nested(
      "margin/accounts/:accountNumber"
    )
  }

  readonly dryRun = async (
    accountNumber: string,
    body: JsonMap,
    options?: RequestOptions
  ): Promise<MarginDryRunResult> => {
    const helper = await this.marginAccountClient.postJson(
      "dry-run",
      body,
      { accountNumber },
      undefined,
      options
    )
    const response = parseSingleResponse(helper, parseMarginDryRunResult)
    if (response.isError) {
      throw new MarginDryRunRejectedError(
        extractErrorMessage(response) ?? REQUEST_FAILED_MESSAGE
      )
    }
    if (!response.hasData()) {
      throw new Error(REQUEST_FAILED_MESSAGE)
    }

    return response.data
  }
}
